import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.SelectUserMenuItem', {
    invitedText: 'Pending',
    notInvitedText: 'Not invited',
});
